import { z } from "zod";
import { comicScriptV1Schema } from "./book-variant.js";
const id = z.string().min(1).max(240);
const digest = z.string().regex(/^[a-f0-9]{64}$/u);
const timestamp = z.string().datetime({ offset: true });
export const comicScriptHistoryEntryV1Schema = z
    .object({
    historyId: id,
    bookId: id,
    scriptId: id,
    parentScriptId: id.nullable(),
    action: z.enum(["SAVE_SCRIPT", "APPROVE_SCRIPT", "RESTORE_SCRIPT"]),
    script: comicScriptV1Schema,
    answerBasisDigestSha256: digest,
    scriptDigestSha256: digest,
    castBasisDigestSha256: digest,
    actorId: id,
    operationDigestSha256: digest,
    approvedAt: timestamp.nullable(),
    createdAt: timestamp,
})
    .strict();
export const comicScriptHistoryV1Schema = z
    .object({
    contract: z.literal("LC_COMIC_SCRIPT_HISTORY_V1"),
    bookId: id,
    currentScriptId: id.nullable(),
    entries: z.array(comicScriptHistoryEntryV1Schema).max(50),
    nextCursor: z.string().min(1).max(4096).nullable(),
    historyBoundary: z
        .object({
        state: z.enum(["RETAINED_FROM_E4", "HISTORICAL_UNAVAILABLE_BEFORE"]),
        firstRetainedAt: timestamp.nullable(),
        version: z.literal("LC_COMIC_SCRIPT_HISTORY_V1"),
    })
        .strict(),
    truthBoundary: z.literal("RETAINED_REVISIONS_ONLY_NO_LEGACY_BACKFILL"),
})
    .strict();
export const restoreComicScriptCommandV1Schema = z
    .object({
    action: z.literal("RESTORE_SCRIPT"),
    historyId: id,
    expectedScriptId: id,
})
    .strict();
export const bedtimeManuscriptHistoryEntryV1Schema = z
    .object({
    historyId: id,
    bookId: id,
    artifactId: id,
    parentArtifactId: id,
    revision: z.number().int().positive(),
    sourceRevision: z.number().int().nonnegative(),
    title: z.string().trim().min(1).max(160),
    // Eight pages on the first profile, twelve in a picture book (2026-11-02).
    spreadLines: z.array(z.string().trim().min(1).max(1_000)).min(8).max(12),
    actorId: id,
    operationDigestSha256: digest,
    sourceBasisDigestSha256: digest,
    createdAt: timestamp,
})
    .strict();
export const bedtimeManuscriptHistoryV1Schema = z
    .object({
    contract: z.literal("LC_BEDTIME_MANUSCRIPT_HISTORY_V1"),
    bookId: id,
    currentArtifactId: id.nullable(),
    entries: z.array(bedtimeManuscriptHistoryEntryV1Schema).max(50),
    nextCursor: z.string().min(1).max(4096).nullable(),
    historyBoundary: z
        .object({
        state: z.enum(["RETAINED_FROM_E4", "HISTORICAL_UNAVAILABLE_BEFORE"]),
        firstRetainedAt: timestamp.nullable(),
        version: z.literal("LC_BEDTIME_MANUSCRIPT_HISTORY_V1"),
    })
        .strict(),
    truthBoundary: z.literal("RETAINED_REVISIONS_ONLY_NO_LEGACY_BACKFILL"),
})
    .strict();
export const restoreBedtimeManuscriptCommandV1Schema = z
    .object({
    historyId: id,
    expectedCurrentArtifactId: id,
    expectedStoryRevision: z.number().int().nonnegative(),
})
    .strict();
//# sourceMappingURL=book-source-history.js.map